// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1Sjcj","subheader":"ReorderModal_subheader__1W1O3","listWrap":"ReorderModal_listWrap___eC-Y"};